module.exports = __webpack_public_path__ + "img/baner.e61f2ce0.png";